module.exports = __webpack_public_path__ + "images/icons/icon-play-db843116.svg";